<template>
<div class="article-result">
    <div @click="$router.push({name:'blog-article',params:{slug:article.slug, category: currentCategory}})">
        <img v-if="article.preview_thumbnail" v-show="imageLoaded" @load="loaded" :src="article.preview_thumbnail">
        <div v-show="!imageLoaded" class="image-placeholder" :style="{'background-image': 'var(--gradient-'+ randomInt +')'}"></div>
        <!-- <div v-show="!imageLoaded" class="image-placeholder" :style="{'background-color': randomBackgroundColor(article.title)}"></div> -->
        <div class="article-result-body">
			<div>
				<span :style="{'background-color': randomBackgroundColor(article.category)}">{{article.category}}</span>
				<small>{{viewsString}}</small>
			</div>

            <h1>{{article.title}}</h1>
			<p>{{article.abstract}}</p>
        </div>
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import Utility from "@/../submodules/vue-base/mixins/Utility";
import Random from "@/../submodules/vue-base/mixins/Random";
export default {

    name: "BlogArticleResult",

	mixins:[
		Utility,
		Random
	],

    data(){
        return {
            imageLoaded: false,
            randomInt: this.getRandomInt(30),
        };
    },

    props: {
        article: {}
    },


    methods: {
	    getRandomInt(max) {
		    return Math.floor(Math.random() * max);
	    },
        loaded(){
            this.imageLoaded = true;
        }
    },

    computed: {
        currentCategory(){
            var result = "All"

            if(this.$route.params.category){
                result = this.$route.params.category
            }

            return result;
        },

		viewsString(){
			var result = this.abbreviateNumber(this.counts_object[this.article.title]);

			result += " view";

			if(this.counts_object[this.article.title]!=1){
				result += "s"
			}

			if(this.counts_object[this.article.title]==0||!this.counts_object[this.article.title]){
				result = "";
			}

			return result;
		},
		...mapGetters(["counts_object"])
    },

}
</script>
